<template>
  <div class="contactus-4 pt-100 pb-150 petit">
    <modal :show.sync="modals.modal1" modal-classes="modal-dialog-centered">
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x" style="color: red;"></i>
        <h4 class="heading mt-4">
          Votre message n'a pas pu être envoyé !
        </h4>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal1 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal :show.sync="modals.modal2" modal-classes="modal-dialog-centered">
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Validation
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-check-bold ni-3x" style="color: green"></i>
        <h4 class="heading mt-4">
          Votre message à été envoyé avec succès
        </h4>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal2 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <modal
      :show.sync="modals.modal3"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Erreur
      </h6>
      <div class="py-3 text-center">
        <i class="ni ni-fat-remove ni-3x" style="color: red;"></i>
        <h4 class="heading mt-4">
          Une erreur grave c'est produite ! Veuillez contacter le cabinet au
          05.61.83.29.13 ou réessayer.
        </h4>
        <br />
        <h5>Code Erreur : NO_API_RETURN_MESSAGE</h5>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="anhod2"
          class="ml-auto"
          @click="modals.modal3 = false"
        >
          Fermer
        </base-button>
      </template>
    </modal>
    <div class="row">
      <div class="col-md-12">
        <div
          class="card card-contact card-raised"
          style="background-color: #3D3D3D;"
        >
          <div class="row">
            <div class="col-lg-12 pr-md-0">
              <div class="card-body txt">
                <h4 style="color: white;">
                  Nouveau Message
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt-50">
      <div class="col-md-12">
        <div class="card card-contact card-raised pt-25 pb-50 bg-lighter">
          <div class="container">
            <div class="row pb-10">
              <div class="col-md-6 pr-md-0">
                <div class="card-body">
                  <a style="color: red;">*</a> Objet du message
                  <v-select
                    v-model="message.type_message"
                    :options="option_message"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-4">
                    Nom
                  </div>
                  <div class="col-md-2"></div>
                  <div class="col-md-6">
                    <base-input
                      placeholder="Nom"
                      addonLeftIcon="ni ni-single-02"
                      name="section"
                      v-model="message.nom"
                      input-classes="base_input"
                    ></base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    Téléphone
                  </div>
                  <div class="col-md-2"></div>
                  <div class="col-md-6">
                    <base-input
                      placeholder="Téléphone"
                      addonLeftIcon="ni ni-mobile-button"
                      name="section"
                      v-model="message.tel"
                      input-classes="base_input"
                    ></base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <a style="color: red;">*</a> E-mail
                  </div>
                  <div class="col-md-2"></div>
                  <div class="col-md-6">
                    <base-input
                      placeholder=" Adresse mail"
                      addonLeftIcon="ni ni-email-83"
                      name="section"
                      v-model="message.mail"
                      input-classes="base_input"
                    ></base-input>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row pb-25">
                  <label><a style="color: red;">*</a> Texte du message</label>
                  <textarea
                    addonLeftIcon="ni ni-align-left-2"
                    placeholder="Saisir votre message ici ..."
                    name="message"
                    class="form-control"
                    rows="6"
                    v-model="message.message"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-md-12">
                <base-button block type="anhod2" @click="Envoyer"
                  >Envoyer le message</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import Modal from "@/components/Modal";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { HTTP_REQUEST } from "../constants/constantes";

export default {
  components: {
    vSelect,
    Modal
  },
  name: "Messages",
  data() {
    return {
      type: this.$route.params.type,

      objet_check: false,
      mail_check: false,
      message_check: false,
      message_erreur_objet: "",
      message_erreur_mail: "",
      message_erreur_message: "",

      message: {
        type_message: "",
        nom: "",
        tel: "",
        mail: "",
        message: "",
        dossier: ""
      },

      option_message: [
        "Envoyer un message",
        "Je souhaite avoir un délai supplémentaire",
        "Je souhaite un délai différent de celui proposé",
        "J'ai déjà réglé",
        "Je souhaite que vous me recontactiez",
        "Modifier vos informations de contact",
        "Demande de document"
      ],

      modals: {
        modal1: false,
        modal2: false,
        modal3: false
      }
    };
  },
  mounted() {
    this.Type();
  },
  created: function() {
    this.verifToken();
  },
  methods: {
    verifToken: function() {
      if (this.$store.state.tokens != "") {
        const self = this;
        let getDataApi = async function() {
          let postAction = "action=Verif_CreateToken";
          let postToken = "&token=" + self.$store.state.tokens;
          let postDossier = "&dossier=0";
          let postMotdepasse = "&motdepasse=0";
          let postData = postAction + postToken + postDossier + postMotdepasse;
          const retourRequete = await axios.post(HTTP_REQUEST, postData);
          return retourRequete;
        };
        getDataApi().then(function(retourApi) {
          if (retourApi.data) {
            if (retourApi.data == "INVALID") {
              self.$store.commit("removeToken", 0);
              self.$store.commit("removeSolde", 0);
              router.push("/login/1/0/0");
            } else if (retourApi.data == "INVALID PARAMS") {
              router.push("/login/1/0/0");
            } else {
              let data = JSON.parse(retourApi.data);
              self.message.dossier = data["dos"];
              let getDataCli = async function() {
                let postAction = "action=getDebiteurInfo";
                let postId = "&debiteur=" + data["deb"];
                let postData = postAction + postId;
                const retourRequete = await axios.post(HTTP_REQUEST, postData);
                return retourRequete;
              };
              getDataCli().then(function(retourApi) {
                if (retourApi.data) {
                  if (retourApi.data == "ERROR_QUERY") {
                    console.log("ERROR QUERY"); // Faire une Modal
                  } else {
                    let data = retourApi.data;
                    self.message.nom = data["Raison_sociale"];
                  }
                }
              });
            }
          }
        });
      } else {
        router.push("/login/1/0/0");
      }
    },
    Type: function() {
      if (this.type == 1) {
        this.message.type_message = this.option_message[0];
      } else if (this.type == 2) {
        this.message.type_message = this.option_message[1];
      } else if (this.type == 3) {
        this.message.type_message = this.option_message[2];
      }
    },
    Envoyer: function() {
      this.objet_check = false;
      this.mail_check = false;
      this.message_check = false;
      // Expr reg pour check si la valeur saisie est bien une adresse mail
      const email = /^(([^<>()[]\.,;:s@]+(.[^<>()[]\.,;:s@]+)*)|(.+))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/;
      if (this.message.type_message == "") {
        this.message_erreur_objet =
          "Veuillez renseigner l'objet de votre message";
        this.objet_check = true;
        this.$toast.open({
          message: this.message_erreur_objet,
          type: "warning",
          duration: 7500,
          position: "top-right"
        });
      }
      if (this.message.mail == "") {
        this.message_erreur_mail = "Veuillez renseigner une adresse mail";
        this.mail_check = true;
        this.$toast.open({
          message: this.message_erreur_mail,
          type: "warning",
          duration: 7500,
          position: "top-right"
        });
      } else if (email.test(this.message.mail) == false) {
        this.message_erreur_mail =
          "Veuillez renseigner une adresse mail valide";
        this.mail_check = true;
        this.$toast.open({
          message: this.message_erreur_mail,
          type: "warning",
          duration: 7500,
          position: "top-right"
        });
      }
      if (this.message.message == "") {
        this.message_erreur_message = "Veuillez renseigner un message";
        this.message_check = true;
        this.$toast.open({
          message: this.message_erreur_message,
          type: "warning",
          duration: 7500,
          position: "top-right"
        });
      }
      if (
        this.objet_check == false &&
        this.mail_check == false &&
        this.message_check == false
      ) {
        if (this.$store.state.tokens != "") {
          const self = this;
          let getDataApi = async function() {
            let action = "action=envoyerMessage";
            let message = "&message=" + JSON.stringify(self.message);
            var postData = action + message;
            const retourRequete = await axios.post(HTTP_REQUEST, postData);
            return retourRequete;
          };
          getDataApi().then(function(retourApi) {
            if (retourApi.data) {
              let data = retourApi.data;
              if (data == "error") {
                self.modals.modal1 = true;
              } else {
                self.modals.modal2 = true;
              }
            } else {
              self.modals.modal3 = true;
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.txt {
  text-align: center;
}
.petit {
  background-image: url("/img/brand/background.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 200%;
  background-attachment: fixed;
  padding-block-end: 20rem;
}
v-select {
  background-color: red;
}
</style>
